import KeyFlowParamVO from './KeyFlowParamVO';

export type StatisticsParamVOProps = {
  taskType?: TaskType;
  // yyyyMMdd
  startDate?: string;
  endDate?: string;
};

export enum TaskType {
  Partial = 'PARTIAL',
  Streaming = 'STREAMING',
  Download = 'DOWNLOAD',
  DownloadFull = 'DOWNLOAD_FULL',
  DownloadPartial = 'DOWNLOAD_PARTIAL',
  Login = 'LOGIN',
  DownloadInterview = 'DOWNLOAD_INTERVIEW',
  DownloadHighlight = 'DOWNLOAD_HIGHLIGHT',
}

export type DownloadType = TaskType.Download | TaskType.DownloadFull | TaskType.DownloadPartial | TaskType.DownloadInterview | TaskType.DownloadHighlight;

class StatisticsParamVO extends KeyFlowParamVO {
  TASK_TYPE?: TaskType;
  // yyyyMMdd
  START_DATE?: string;
  END_DATE?: string;

  constructor(data: StatisticsParamVOProps) {
    super();
    this.TASK_TYPE = data.taskType;
    this.START_DATE = data.startDate;
    this.END_DATE = data.endDate;
  }
}

export default StatisticsParamVO;
